
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { PsychologistCardData } from './types';

interface PsychologistCardDurationsProps {
  psychologist: PsychologistCardData;
}

const PsychologistCardDurations: React.FC<PsychologistCardDurationsProps> = ({ psychologist }) => {
  const { data: pricingData } = useQuery({
    queryKey: ['psychologist-pricing', psychologist.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('psychologist_pricing')
        .select('price_30min, price_60min, currency, is_active')
        .eq('psychologist_id', psychologist.id)
        .eq('is_active', true)
        .single();
      
      if (error) {
        console.error('Error fetching pricing:', error);
        return null;
      }
      
      return data;
    },
    enabled: !!psychologist.id,
  });

  // Use real-time pricing data if available, senão usar fallback
  const pricing = pricingData ? {
    price_30min: pricingData.price_30min,
    price_60min: pricingData.price_60min
  } : {
    price_30min: Math.round((psychologist.price || 150) * 0.8),
    price_60min: psychologist.price || 280
  };

  return (
    <div className="mb-4">
      <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
        PREÇOS POR SESSÃO
      </h4>
      
      <div className="flex items-center justify-center gap-2 text-sm flex-wrap">
        {pricing.price_30min && (
          <>
            <span className="text-gray-700 font-medium">30min - R${pricing.price_30min}</span>
            {pricing.price_60min && <span className="text-gray-400">|</span>}
          </>
        )}
        {pricing.price_60min && (
          <span className="text-gray-700 font-medium">60min - R${pricing.price_60min}</span>
        )}
      </div>
    </div>
  );
};

export default PsychologistCardDurations;
